import { v4 as uuidv4 } from 'uuid';
import i18n from '../../../i18n';
import { NewsMakerGrid } from './NewsMakerGrid';
import { NewsMakerPluginSettings } from './NewsMakerPluginSettings';

const t = (value: string) => i18n.t('sidePanel.' + value)

export const NewsMakerTab = (): ITab => {
    return {
        id: uuidv4(),
        title: t('service.submenu.newsMaker'),
        view: {
            content: NewsMakerPluginSettings
                ? <NewsMakerGrid
                    gridId={uuidv4()}
                    plugin={NewsMakerPluginSettings}
                />
                : <p> {t('general.directoryNotConfigured')} </p>
        }
    }
}